import { env } from '@/env';
import { isDevelopmentRuntime } from '@/lib/runtime-flags';
import { getBrowserWindow } from '@/lib/utils/browser-window';

const DEBUG_ENABLED = env.NEXT_PUBLIC_ENABLE_RT_DEBUG || isDevelopmentRuntime;

type DebugRegistry = Record<string, unknown>;

declare global {
  interface Window {
    __sweetisticsDebug?: DebugRegistry;
  }
}

/**
 * Registers a payload under `window.__sweetisticsDebug[namespace]` when runtime debugging is enabled.
 * This helper is intentionally generic so any subsystem (realtime, cache, timeline, etc.) can expose
 * lightweight inspection hooks without wiring bespoke globals.
 */
export function registerDebugNamespace<TPayload>(namespace: string, payload: TPayload): void {
  if (!DEBUG_ENABLED) {
    return;
  }
  const browserWindow = getBrowserWindow();
  if (!(browserWindow && namespace)) {
    return;
  }

  browserWindow.__sweetisticsDebug ??= {};
  browserWindow.__sweetisticsDebug[namespace] = payload;
}
